import React, { FC } from "react";

import { Formik } from "formik";

import { IFormProps, FChildren } from "./Interfaces/IFormProps";

const Form: FC<IFormProps> = ({
  schema,
  style,
  initialValues,
  children,
  onSubmit,
}) => {
  const isFunction = typeof children === "function";
  const FChildrenVar = children as FChildren;
  return (
    <Formik
      initialValues={initialValues}
      style={style}
      validationSchema={schema}
      onSubmit={onSubmit}
      enableReinitialize={true}
    >
      {(props) => (isFunction ? FChildrenVar && FChildrenVar(props) : children)}
    </Formik>
  );
};

export { Form };
